module.exports = __webpack_public_path__ + "static/img/icon_fascia.da447f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_fascia.png
// module id = Hbj/
// module chunks = 23